import { z } from 'zod';

const RecruitmentCampaignCategoryItemSchema = z
  .object({
    categoryNo: z.string(),
    categoryName: z.string(),
  })
  .describe('RecruitmentCampaignCategoryItem');

export type RecruitmentCampaignCategoryItem = z.infer<typeof RecruitmentCampaignCategoryItemSchema>;

export const GetRecruitmentCampaignCategoriesServiceResponseSchema = z
  .object({
    categories: z.array(RecruitmentCampaignCategoryItemSchema),
  })
  .describe('GetRecruitmentCampaignCategoriesServiceResponseSchema');

export type GetRecruitmentCampaignCategoriesServiceResponse = z.infer<
  typeof GetRecruitmentCampaignCategoriesServiceResponseSchema
>;
